import AbstractProvider from '../services/App/AbstractProvider';
import {IDispatcher} from '@src/@interfaces/services/Events';
import {HttpEvents} from '@src/@types/services/Http/Http';
import {ILocalisation} from '@src/@interfaces/services/Localisation/ILocalisation';
import {LocalisationEvents} from '@src/@types/services/Localisation/Localisation';

export class LanguageProvider extends AbstractProvider {
    async boot(): Promise<void> {
        const localisation = this.getStoredService<ILocalisation>('trans');
        const dispatcher = this.getStoredService<IDispatcher>('events');

        let currentLocale = localisation.getLocale();
        localisation.listen(LocalisationEvents.SET_LOCALE, (e, payload) => {
            currentLocale = payload.newLocale ?? currentLocale;
        });

        dispatcher.listen<any>(HttpEvents.BEFORE_SEND_REQUEST, (event, payload) => {
            payload.options.headers.set('X-Lang', currentLocale);
        });
    }
}
